module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart":"График","intensity":"Интенсивность","detector":"Детектор:","filter":"Фильтровать:","day":"Сутки","week":"Неделя","month":"Месяц","flex":"Произвольный","from":"Начало","to":"Окончание"},"en":{"chart":"Chart","intensity":"Intensity","detector":"Detector:","filter":"Filter:","day":"Day","week":"Week","month":"Month","flex":"Flex","from":"From","to":"To"}}')
  delete Component.options._Ctor
}
